/* eslint-disable */
import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { operationsApi } from "./api";
import useModalA11y from "../utils/useModalA11y";
import "./StaffDialogs.css";

export default function EditStaffDialog({ member, onClose, onSaved }) {
  const modalRef = useModalA11y({ isOpen: true, onClose });
  const [roles, setRoles] = useState([]);
  const [form, setForm] = useState({
    full_name: member.full_name || "",
    phone: member.phone || "",
    alt_phone: member.alt_phone || "",
    role: member.role,
    notes: member.notes || "",
    employed_since: member.employed_since || "",
  });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    operationsApi.listRoles().then(setRoles).catch(() => {});
  }, []);

  const update = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e?.preventDefault();
    const digits = form.phone.replace(/\D/g, "").slice(-10);
    if (digits.length !== 10) {
      setError("Phone must be a 10-digit Indian number");
      return;
    }
    setBusy(true);
    setError("");
    try {
      await operationsApi.patchStaff(member.id, {
        full_name: form.full_name.trim(),
        phone: digits,
        alt_phone: form.alt_phone.trim() || null,
        role: form.role,
        notes: form.notes.trim() || null,
        employed_since: form.employed_since || null,
      });
      onSaved && onSaved();
    } catch (err) {
      setError(err.message || "Could not save");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="vsop-overlay" onClick={onClose}>
      <form
        ref={modalRef}
        className="vsop-modal"
        onClick={(e) => e.stopPropagation()}
        onSubmit={submit}
        role="dialog"
        aria-modal="true"
        aria-labelledby="vsop-edit-title"
      >
        <div className="vsop-modal-head">
          <h2 id="vsop-edit-title">Edit {member.full_name}</h2>
          <button
            type="button"
            className="vsop-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>

        <div className="vsop-modal-field">
          <label htmlFor="vsop-e-name">Full name</label>
          <input
            id="vsop-e-name"
            type="text"
            value={form.full_name}
            onChange={(e) => update("full_name", e.target.value)}
            required
            maxLength={255}
          />
        </div>

        <div className="vsop-modal-field">
          <label htmlFor="vsop-e-role">Role</label>
          <select
            id="vsop-e-role"
            value={form.role}
            onChange={(e) => update("role", e.target.value)}
          >
            {roles.map((r) => (
              <option
                key={r.value}
                value={r.value}
                disabled={
                  r.value === "FACILITY_MANAGER" &&
                  member.role !== "FACILITY_MANAGER"
                }
              >
                {r.label}
              </option>
            ))}
          </select>
        </div>

        <div className="vsop-modal-row">
          <div className="vsop-modal-field">
            <label htmlFor="vsop-e-phone">Phone</label>
            <input
              id="vsop-e-phone"
              type="tel"
              inputMode="numeric"
              value={form.phone}
              onChange={(e) =>
                update("phone", e.target.value.replace(/\D/g, "").slice(0, 10))
              }
              required
              maxLength={10}
            />
          </div>
          <div className="vsop-modal-field">
            <label htmlFor="vsop-e-alt">Alt phone</label>
            <input
              id="vsop-e-alt"
              type="tel"
              inputMode="numeric"
              value={form.alt_phone}
              onChange={(e) =>
                update(
                  "alt_phone",
                  e.target.value.replace(/\D/g, "").slice(0, 10)
                )
              }
              maxLength={10}
            />
          </div>
        </div>

        <div className="vsop-modal-field">
          <label htmlFor="vsop-e-since">Employed since</label>
          <input
            id="vsop-e-since"
            type="date"
            value={form.employed_since}
            onChange={(e) => update("employed_since", e.target.value)}
          />
        </div>

        <div className="vsop-modal-field">
          <label htmlFor="vsop-e-notes">Notes</label>
          <textarea
            id="vsop-e-notes"
            rows={2}
            value={form.notes}
            onChange={(e) => update("notes", e.target.value)}
            maxLength={2000}
          />
        </div>

        {error && <div className="vsop-modal-error">{error}</div>}

        <div className="vsop-modal-actions">
          <button
            type="button"
            className="vsop-btn-secondary"
            onClick={onClose}
            disabled={busy}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="vsop-btn-primary"
            disabled={busy}
          >
            {busy ? "Saving…" : "Save changes"}
          </button>
        </div>
      </form>
    </div>
  );
}
